import { Ability, AbilityClass } from '@casl/ability';
import { createContextualCan } from '@casl/react';
import { createContext, use } from 'react';
import type {
  HelproomShiftPermissions,
  HelproomsNamespaces,
  HotlinesNameSpaces,
  OmniChannelShiftPermissions, ResourcesNameSpaces, RHSPermissions, ShiftNames, UserPermission, WorkspacesNamespaces
} from '../../algebra/constants';


/**
 * Possible Actions And Subjects
 */
export type Actions =
  | typeof RHSPermissions[keyof typeof RHSPermissions]
  | typeof OmniChannelShiftPermissions[keyof typeof OmniChannelShiftPermissions]
  | typeof HelproomShiftPermissions[keyof typeof HelproomShiftPermissions]
  | typeof UserPermission[keyof typeof UserPermission];

export type Subjects =
  | typeof WorkspacesNamespaces[keyof typeof WorkspacesNamespaces]
  | typeof HelproomsNamespaces[keyof typeof HelproomsNamespaces]
  | typeof HotlinesNameSpaces[keyof typeof HotlinesNameSpaces]
  | typeof ResourcesNameSpaces[keyof typeof ResourcesNameSpaces]
  | typeof ShiftNames[keyof typeof ShiftNames];

export type AppAbility = Ability<[Actions, Subjects]>;
export const AppAbilities = Ability as AbilityClass<AppAbility>;

/**
 * Usages
 */
export const AbilityContext = createContext<AppAbility>(null as unknown as AppAbility);
export const Can = createContextualCan(AbilityContext.Consumer);
export const useAbilitiesCtx = () => use(AbilityContext);
